/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createProblemDetailsFromDiscriminatorValue, serializeUpdateServiceProviderSettingsCompanyRegistrationCommand, type ProblemDetails, type UpdateServiceProviderSettingsCompanyRegistrationCommand } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /serviceprovidersettings/company-registration
 */
export interface CompanyRegistrationRequestBuilder extends BaseRequestBuilder<CompanyRegistrationRequestBuilder> {
    /**
     * UpdateServiceProviderSettingsCompanyRegistration
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     put(body: UpdateServiceProviderSettingsCompanyRegistrationCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * UpdateServiceProviderSettingsCompanyRegistration
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: UpdateServiceProviderSettingsCompanyRegistrationCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const CompanyRegistrationRequestBuilderUriTemplate = "{+baseurl}/serviceprovidersettings/company-registration";
/**
 * Metadata for all the requests in the request builder.
 */
export const CompanyRegistrationRequestBuilderRequestsMetadata: RequestsMetadata = {
    put: {
        uriTemplate: CompanyRegistrationRequestBuilderUriTemplate,
        responseBodyContentType: "application/problem+json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeUpdateServiceProviderSettingsCompanyRegistrationCommand,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
